import { Action } from '../../common/actions/core/action';
import { Invoice } from '../services/invoice.model';

export class BillInfoChangeAction implements Action {
  constructor(public invoice: Invoice) {}
}



// WEBPACK FOOTER //
// src/app/buy/bill-info/bill-info.action.ts